// Game Changers v1.1 - Lista delle carte bandite
// Massimo 3 carte totali per deck

export const GAME_CHANGERS_BANLIST = [
  // White Cards
  'Drannith Magistrate',
  'Enlightened Tutor',
  'Humility',
  "Serra's Sanctum",
  'Smothering Tithe',
  "Teferi's Protection",

  // Blue Cards
  'Consecrated Sphinx',
  'Cyclonic Rift',
  'Expropriate',
  'Force of Will',
  'Fierce Guardianship',
  'Gifts Ungiven',
  'Intuition',
  'Jin-Gitaxias, Core Augur',
  'Mystical Tutor',
  'Narset, Parter of Veils',
  'Rhystic Study',
  'Sway of the Stars',
  "Thassa's Oracle",
  'Urza, Lord High Artificer',

  // Black Cards
  "Bolas's Citadel",
  'Braids, Cabal Minion',
  'Demonic Tutor',
  'Imperial Seal',
  'Necropotence',
  'Opposition Agent',
  'Orcish Bowmasters',
  'Tergrid, God of Fright',
  'Vampiric Tutor',
  'Ad Nauseam',

  // Red Cards
  'Deflecting Swat',
  'Gamble',
  "Jeska's Will",
  'Underworld Breach',

  // Green Cards
  'Crop Rotation',
  'Food Chain',
  "Gaea's Cradle",
  'Natural Order',
  'Seedborn Muse',
  'Survival of the Fittest',
  'Vorinclex, Voice of Hunger',
  'Worldly Tutor',

  // Multicolored Cards
  'Aura Shards',
  'Coalition Victory',
  'Grand Arbiter Augustin IV',
  'Kinnan, Bonder Prodigy',
  "Yuriko, the Tiger's Shadow",
  'Notion Thief',
  'Winota, Joiner of Forces',

  // Colorless Cards
  'Ancient Tomb',
  'Chrome Mox',
  'Field of the Dead',
  'Glacial Chasm',
  'Grim Monolith',
  "Lion's Eye Diamond",
  'Mana Vault',
  "Mishra's Workshop",
  'Mox Diamond',
  'Panoptic Mirror',
  'The One Ring',
  'The Tabernacle at Pendrell Vale',
];

// Funzione per controllare se un deck ha carte bandite
export const checkBannedCards = (deck) => {
  if (!deck.deck || !Array.isArray(deck.deck))
    return { hasBanned: false, bannedCards: [] };

  const bannedCards = deck.deck.filter((card) => {
    const cardName = card.name || card.nome;
    return GAME_CHANGERS_BANLIST.includes(cardName);
  });

  return {
    hasBanned: bannedCards.length > 0,
    bannedCards,
    count: bannedCards.length,
  };
};

// Funzione per verificare se un deck supera il limite di 3 carte
export const checkGameChangersLimit = (deck) => {
  const { bannedCards } = checkBannedCards(deck);

  if (bannedCards.length === 0) return { isOverLimit: false, count: 0 };

  // Conta le quantità totali delle carte bandite
  const totalBannedCount = bannedCards.reduce((total, card) => {
    return total + (card.quantity || 1);
  }, 0);

  return {
    isOverLimit: totalBannedCount > 3,
    count: totalBannedCount,
    limit: 3,
  };
};
